<template>
  <div class="item-container">
    <div class="type-label">{{ state.questionType }}</div>
    <div class="question-container">
      <div class="question-header">
        <div class="question-number">
          {{ titleIndex + 1 }}{{ biaodian }}{{ state.caseProblem }}
        </div>

        <div class="question-statistics">
          填写率: {{ state.dataObj.completionRate }}% / 填写人数:
          {{ state.dataObj.validResponses }}人
        </div>
      </div>

      <div
        v-if="
          state.questionType === '多项填空' || state.questionType === '排序'
        "
        class="content-container"
        :scroll-x="true"
      >
        <div class="table-container">
          <div class="table-header">
            <div
              v-for="(item, index) in state.headerList"
              :key="index"
              style="
                padding: 10px;
                min-width: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: 1;
                border-right: 1px solid #dcdde0;
                border-bottom: 1px solid #dcdde0;
                word-break: break-all;
              "
            >
              <div>{{ item }}</div>
            </div>
          </div>
          <div
            v-for="(item, index) in state.tableList"
            :key="index"
            class="table-row"
          >
            <div
              v-for="(subItem, subIndex) in item"
              :key="subIndex"
              style="
                padding: 10px;
                min-width: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: 1;
                border-right: 1px solid #dcdde0;
                border-bottom: 1px solid #dcdde0;
                word-break: break-all;
              "
            >
              <div>{{ subItem }}</div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="
          state.questionType === '下载文件' || state.questionType === '上传文件'
        "
        class="table-uploadFile"
        style="border-left: 2px solid #dcdde0; border-top: 2px solid #dcdde0"
      >
        <div class="table-header">
          <div class="table-cell number-cell"><p>编号</p></div>
          <div class="table-cell address-cell"><p>文件名</p></div>
          <div
            class="table-cell count-cell"
            v-if="state.questionType != '上传文件'"
          >
            <p>下载次数</p>
          </div>
        </div>

        <div
          v-for="(item, index) in state.tableList"
          :key="index"
          class="table-row"
        >
          <div class="table-cell number-cell">
            <p>{{ item.number }}</p>
          </div>
          <div class="table-cell address-cell">
            <p>{{ item.fileName }}</p>
          </div>

          <div
            class="table-cell count-cell"
            v-if="state.questionType != '上传文件'"
          >
            <p>{{ item.downloadCount }}</p>
          </div>
        </div>
      </div>

      <div
        v-else-if="state.questionType === 'MaxDiff'"
        class="content-container"
        :scroll-x="true"
      >
        <div
          class="table-container"
          style="margin-bottom: 0; border-top: 2px solid #dcdde0"
        >
          <div style="display: flex">
            <div
              v-for="(header, index) in state.headerList"
              :key="'header-' + index"
              style="
                width: 140px;
                border-right: 2px solid #dcdde0;
                border-bottom: 2px solid #dcdde0;
                padding: 20px;
                word-break: break-all;
                overflow-wrap: break-word;
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              {{ header }}
            </div>
          </div>
        </div>

        <div class="table-container" style="flex-direction: column">
          <div
            v-for="(row, rowIndex) in state.tableList"
            :key="'row-' + rowIndex"
            style="display: flex"
          >
            <div
              v-for="(header, colIndex) in state.headerList"
              :key="'col-' + rowIndex + '-' + colIndex"
              style="
                width: 140px;
                border-right: 2px solid #dcdde0;
                border-bottom: 2px solid #dcdde0;
                padding: 20px;
                word-break: break-all;
                overflow-wrap: break-word;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div v-if="colIndex == 0">
                {{ row.attributeName ? row.attributeName : "-" }}
              </div>
              <div v-else-if="colIndex == 1">
                {{ row.occurrenceCount ? row.occurrenceCount : 0 }}
              </div>
              <div v-else-if="colIndex == 2">
                {{ row.bestLabelCount ? row.bestLabelCount : 0 }}
              </div>
              <div v-else-if="colIndex == 3">
                {{ row.worstLabelCount ? row.worstLabelCount : 0 }}
              </div>
              <div v-else-if="colIndex == 4">
                {{
                  typeof row.bestProbability == "number"
                    ? row.bestProbability.toFixed(4)
                    : row.bestProbability
                    ? row.bestProbability
                    : "-"
                }}
              </div>
              <div v-else-if="colIndex == 5">
                {{
                  typeof row.preferenceShare == "number"
                    ? (row.preferenceShare * 100).toFixed(2) + "%"
                    : row.preferenceShare
                    ? row.preferenceShare
                    : "-"
                }}
              </div>
              <div v-else-if="colIndex == 6">
                {{ row.score ? row.score : 0 }}
              </div>
              <div v-else>-</div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="state.questionType === '学历'"
        style="border-left: 2px solid #dcdde0; border-top: 2px solid #dcdde0"
      >
        <div class="table-header">
          <div class="table-cell number-cell">
            <p>学历</p>
          </div>
          <div class="table-cell address-cell">
            <p>数量</p>
          </div>
        </div>
        <div
          v-for="(item, index) in state.tableList"
          :key="index"
          class="table-row"
        >
          <div class="table-cell number-cell">
            <p>{{ item.text }}</p>
          </div>
          <div class="table-cell address-cell">
            <p>{{ item.count }}</p>
          </div>
        </div>
      </div>

      <div v-else class="table-container">
        <div class="table-header">
          <div class="table-cell number-cell">
            <div>编号</div>
          </div>
          <div class="table-cell address-cell">
            <div>{{ state.questionType }}</div>
          </div>
        </div>
        <div
          v-for="(item, index) in state.tableList"
          :key="index"
          class="table-row"
        >
          <div class="table-cell number-cell">
            <div>{{ item.number }}</div>
          </div>
          <div class="table-cell address-cell">
            <div>{{ item.content }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="option-list">
                <div v-for="(item, index) in state.questionList" :key="index">
                    <div class="option-item" v-for="(subItem, subIndex) in item.list">
                        <div class="option-text">编号</div>
                        <div class="option-stat">
                            <span class="option-percentage">{{ subItem.percentage }}%</span>
                            <span class="option-votes">{{ subItem.count }}人</span>
                        </div>

                    </div>

                </div>
            </div> -->
    </div>

    <!-- <div style="width: 600px;min-height: 10px;" v-if="state.questionType === '单选题' || state.questionType === '多选题'">



        </div> -->
  </div>
</template>

<script>
export default {
  name: "AnalysisChart",
  props: {
    dataObj: { type: Object, default: () => ({}) },
    titleIndex: { type: Number, default: 0 },
  },

  watch: {
    dataObj: {
      handler(newValue, oldVal) {
        if (newValue.type === this.QuestionType.MaxDiff) {
          console.log(newValue, "table类型newValue");
        }

        if (JSON.parse(newValue.analyzer) === null) {
          this.state.tableList = [];
        } else {
          this.state.dataObj = JSON.parse(newValue.analyzer);
          if (newValue.type === this.QuestionType.MBQ) {
            this.state.headerList = JSON.parse(newValue.analyzer).tableHead;
            this.state.tableList = JSON.parse(newValue.analyzer).tableData;
          } else if (newValue.type === this.QuestionType.SORT) {
            const parsed = JSON.parse(newValue.analyzer);
            const answerSequence = parsed.answerSequence || [];
            const maxLen =
              answerSequence.length > 0 ? answerSequence[0].sequence.length : 0;

            this.state.headerList = ["编号"];
            for (let i = 1; i <= maxLen; i++) {
              this.state.headerList.push(`选项${i}`);
            }

            this.state.tableList = answerSequence.map((item, index) => {
              return [item.order || index + 1, ...item.sequence];
            });
          } else if (newValue.type === this.QuestionType.MaxDiff) {
            console.log(newValue.analyzer, "MaxDiff parsed 000000");
            this.state.headerList = JSON.parse(newValue.analyzer).tableHead;
            this.state.tableList = JSON.parse(newValue.analyzer).tableData;
            console.log("this.state.headerList", this.state.headerList);
            console.log("this.state.tableList", this.state.tableList);
          } else if (newValue.type === this.QuestionType.DownloadFile) {
            this.state.headerList = JSON.parse(newValue.analyzer).tableHead;
            this.state.tableList = JSON.parse(newValue.analyzer).tableData;
          } else if (newValue.type === this.QuestionType.UploadFile) {
            this.state.headerList = JSON.parse(newValue.analyzer).tableHead;
            this.state.tableList = JSON.parse(newValue.analyzer).tableData;
          } else {
            this.state.tableList = JSON.parse(newValue.analyzer).table;
          }
        }

        this.state.caseProblem = newValue.caseProblem;
        if (newValue.type === this.QuestionType.SCQ) {
          this.state.questionType = "单选";
        }
        if (newValue.type === this.QuestionType.MCQ) {
          this.state.questionType = "多选";
        }
        if (newValue.type === this.QuestionType.SBQ) {
          this.state.questionType = "填空";
        }
        if (newValue.type === this.QuestionType.MBQ) {
          this.state.questionType = "多项填空";
        }
        if (newValue.type === this.QuestionType.DLQ) {
          this.state.questionType = "下拉";
        }
        if (newValue.type === this.QuestionType.NPS) {
          this.state.questionType = "NPS";
        }
        if (newValue.type === this.QuestionType.VOTE) {
          this.state.questionType = "投票";
        }
        if (newValue.type === this.QuestionType.SORT) {
          this.state.questionType = "排序";
        }
        if (newValue.type === this.QuestionType.REMARK) {
          this.state.questionType = "备注";
        }
        if (newValue.type === this.QuestionType.SCORE) {
          this.state.questionType = "评分";
        }
        if (newValue.type === this.QuestionType.QA) {
          this.state.questionType = "问答";
        }
        if (newValue.type === this.QuestionType.WRQ) {
          this.state.questionType = "权重评分";
        }
        if (newValue.type === this.QuestionType.SRQ) {
          this.state.questionType = "评星";
        }
        if (newValue.type === this.QuestionType.NAME) {
          this.state.questionType = "姓名";
        }
        if (newValue.type === this.QuestionType.GENDER) {
          this.state.questionType = "性别";
        }
        if (newValue.type === this.QuestionType.AGE) {
          this.state.questionType = "年龄";
        }
        if (newValue.type === this.QuestionType.TEL) {
          this.state.questionType = "电话";
        }
        if (newValue.type === this.QuestionType.EMAIL) {
          this.state.questionType = "邮箱";
        }
        if (newValue.type === this.QuestionType.DATE) {
          this.state.questionType = "日期";
        }
        if (newValue.type === this.QuestionType.TIME) {
          this.state.questionType = "时间";
        }
        if (newValue.type === this.QuestionType.ADDR) {
          this.state.questionType = "地址";
        }
        if (newValue.type === this.QuestionType.DownloadFile) {
          this.state.questionType = "下载文件";
        }
        if (newValue.type === this.QuestionType.UploadFile) {
          this.state.questionType = "上传文件";
        }
        if (newValue.type === this.QuestionType.BDQ) {
          this.state.questionType = "出生日期";
        }
        if (newValue.type === this.QuestionType.IDQ) {
          this.state.questionType = "身份证号";
        }
        if (newValue.type === this.QuestionType.ELQ) {
          this.state.questionType = "学历";
        }
        if (newValue.type === this.QuestionType.WX) {
          this.state.questionType = "微信号";
        }
        if (newValue.type === this.QuestionType.MaxDiff) {
          this.state.questionType = "MaxDiff";
        }
        if (newValue.type === this.QuestionType.CASCADER) {
          this.state.questionType = "联级题";
        }
        console.log(this.state, "TABLE this.state");
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      QuestionType: this.$store.getters["question/getQuestionType"],
      lineChart: null,
      columnChart: null,
      ringChart: null,
      biaodian: "、",
      questionList: [],

      state: {
        tableList: [],
        headerList: [],
        dataObj: {},
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.item-container {
  background-color: #ffffff;
  width: 100%;
  /*padding: 30px;*/
  /* border-radius: 20px; */
  position: relative;
  /* margin: 20px; */
  /*box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);*/
  display: flex;
  margin-top: 15px;
}

.question-container {
  padding: 1rem;
  /* border: 1px solid #eee; */
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  width: 600px;
  margin: 0 auto;
  margin-top: 50px;
}

.question-header {
  display: flex;
  align-items: baseline;
  margin-bottom: 0.5rem;
  color: #2c3e50;
  justify-content: space-between;
}

.question-number {
  font-weight: normal;
  font-size: 14px;
  word-break: break-all;
  font-family: auto;
  /* width: 420px; */
}

.question-type {
  margin-right: 0.5rem;
  font-size: 14px;
  margin: 10px;
}

.question-statistics {
  font-size: 12px;
  color: #666;
  /* word-break: break-all; */
}

.question-input {
  margin-bottom: 1rem;
  padding: 0.8rem;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: #666;
  background-color: #f8f9fa;
  font-size: 14px;
}

.option-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.option-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem;
  border: 1px solid #a0a0a0;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.option-item:hover {
  border-color: #409eff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.option-text {
  flex: 1;
  margin-right: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.option-stat {
  display: flex;
  align-items: center;
  min-width: 80px;
  justify-content: flex-end;
}

.option-percentage {
  margin-right: 0.5rem;
  color: #409eff;
  font-weight: 500;
}

.option-votes {
  color: #666;
  font-size: 12px;
}

.chart-options {
  display: flex;
  /* justify-content: flex-end; */
  margin-top: 20px;
}

.table-container {
  border-left: 1px solid #dcdde0;
  border-top: 1px solid #dcdde0;
  /*border-radius: 8px;*/
  margin-bottom: 30px;
}

.table-header {
  display: flex;
  /*border-bottom: 1px solid #DCDDE0;*/
  background-color: #f9f9f9;
  /* height: 50px; */
}

.table-row {
  display: flex;
  border-bottom: 1px solid #dcdde0;
}

.table-row:last-child {
  border-bottom: none;
}

.table-cell {
  padding: 20px;
  display: flex;
  align-items: center;
  border-right: 1px solid #dcdde0;
  border-bottom: 1px solid #dcdde0;
}

.number-cell {
  /*flex: 1;*/
  width: 120px;
  justify-content: center;
  border-right: 1px solid #dcdde0;
  border-bottom: 1px solid #dcdde0;
  font-size: 14px;
  padding: 0;
}

.type-label {
  color: #00c389;
  font-size: 16px;
  font-weight: bold;
  font-family: auto;
  background: linear-gradient(
    180deg,
    rgba(0, 179, 128, 0.11),
    rgba(0, 179, 128, 0)
  );
  /* border-radius: 7px 0 10px 0; */
  position: absolute;
  top: -20px;
  left: -20px;
  padding: 6px 17px 18px 17px;
  margin: 20px;
}

.address-cell {
  flex: 3;
  font-size: 14px;
  padding: 10px 20px;
}
.content-container {
  width: 100%;
  /* height: 50px; */
}
.table-container .table-header > div {
  font-weight: normal;
  font-size: 14px;
  font-family: auto;
}

.table-uploadFile .number-cell {
  flex: 25%;
}

.table-uploadFile .address-cell {
  flex: 50%;
}

.table-uploadFile .count-cell {
  flex: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/AnalysisTable.vue